{
  "name": "sippy-web",
  "version": "3.19.3",
  "description": "Cloud PBX from Sippy",
  "keywords": [],
  "license": "UNLICENSED",
  "author": "Sippy",
  "contributors": [
    {
      "name": "Timothy Vanderaerden"
    },
    {
      "name": "Yannick Franssen"
    }
  ],
  "repository": {
    "type": "git",
    "url": "https://dev.sippy.cloud/sippy/sippy-web"
  },
  "type": "module",
  "scripts": {
    "analyze": "npx node-modules-inspector",
    "build": "vite build",
    "build:dev": "vite build --mode dev",
    "build:docs": "vite build --mode docs",
    "build:staging": "vite build --mode staging",
    "fix": "oxfmt && oxlint --fix",
    "format": "oxfmt --check",
    "format:fix": "oxfmt",
    "lint": "oxlint",
    "lint:fix": "oxlint --fix",
    "lint:github": "oxlint --format=github",
    "preview": "vite preview --port 3000",
    "preview:host": "vite preview --host",
    "screenshots:auth": "shot-scraper auth http://localhost:3000 screenshots/auth.json",
    "screenshots:dark": "shot-scraper multi screenshots/screenshots-dark.yaml -a screenshots/auth.json --reduced-motion --retina",
    "screenshots:light": "shot-scraper multi screenshots/screenshots.yaml -a screenshots/auth.json --reduced-motion --retina",
    "screenshots:unauth:dark": "shot-scraper multi screenshots/screenshots-unauth-dark.yaml --reduced-motion --retina",
    "screenshots:unauth:light": "shot-scraper multi screenshots/screenshots-unauth.yaml --reduced-motion --retina",
    "screenshots:update:dark": "shot-scraper multi screenshots/screenshots-update-dark.yaml -a screenshots/auth.json --reduced-motion --retina",
    "screenshots:update:light": "shot-scraper multi screenshots/screenshots-update.yaml -a screenshots/auth.json --reduced-motion --retina",
    "start": "vite serve --mode dev",
    "test": "echo \"Error: no test specified\" && exit 1"
  },
  "dependencies": {
    "@base-ui/react": "^1.9.0",
    "@dnd-kit/helpers": "^0.5.0",
    "@dnd-kit/react": "^0.5.0",
    "@emotion/react": "11.14.0",
    "@emotion/styled": "11.14.1",
    "@firebase/app": "^0.16.3",
    "@firebase/auth": "^1.13.7",
    "@firebase/firestore": "^4.18.0",
    "@mui/material": "^9.5.0",
    "@mui/x-date-pickers": "^9.15.0",
    "@reduxjs/toolkit": "2.13.0",
    "@sippy-platform/valkyrie": "1.0.1",
    "@tanstack/charts": "^1.1.0",
    "@tanstack/highlight": "^1.1.0",
    "@tanstack/react-form": "^1.33.5",
    "@tanstack/react-hotkeys": "^0.13.0",
    "@tanstack/react-pacer": "^0.24.1",
    "@tanstack/react-query": "^5.104.2",
    "axios": "^1.20.0",
    "check-password-strength": "3.0.0",
    "cn": "^0.4.0",
    "country-flag-emoji-polyfill": "0.1.10",
    "date-fns": "^4.4.0",
    "date-holidays": "^3.37.0",
    "js-file-download": "0.4.12",
    "jwt-decode": "4.0.0",
    "prop-types": "15.8.1",
    "qrcode.react": "4.2.0",
    "react": "^19.3.0",
    "react-dom": "^19.3.0",
    "react-dropzone": "^20.1.3",
    "react-redux": "9.3.0",
    "react-router": "^8.4.0",
    "react-selectable-fast": "3.4.0",
    "react-window": "^2.3.4",
    "zod": "^4.6.6"
  },
  "devDependencies": {
    "@tailwindcss/vite": "^4.3.3",
    "@tanstack/devtools-vite": "^0.8.5",
    "@tanstack/eslint-plugin-query": "^5.104.2",
    "@tanstack/react-devtools": "^0.10.13",
    "@tanstack/react-form-devtools": "^0.2.34",
    "@tanstack/react-hotkeys-devtools": "^0.10.0",
    "@tanstack/react-pacer-devtools": "^0.9.1",
    "@tanstack/react-query-devtools": "^5.104.2",
    "@types/react": "^19.3.0",
    "@types/react-dom": "^19.3.0",
    "@vitejs/plugin-react": "^6.1.2",
    "oxc-transform-react": "^0.153.0",
    "oxfmt": "^0.72.0",
    "oxlint": "^1.87.0",
    "rollup-plugin-visualizer": "^7.1.1",
    "tailwindcss": "^4.3.3",
    "typescript": "7.0.2",
    "vite": "^8.3.4"
  },
  "engines": {
    "node": ">=24",
    "npm": "use pnpm",
    "pnpm": ">=11"
  },
  "packageManager": "pnpm@12.11.2",
  "globals": {},
  "sippy": {
    "date": "2026-07-31",
    "api": "3",
    "nextApi": "4"
  }
}
